module.exports = __webpack_public_path__ + "static/media/ao.ab8cc21b.svg";